import { render, staticRenderFns } from "./GeneralDashboard.vue?vue&type=template&id=240c2fd8"
import script from "./GeneralDashboard.vue?vue&type=script&lang=js"
export * from "./GeneralDashboard.vue?vue&type=script&lang=js"
import style0 from "./GeneralDashboard.vue?vue&type=style&index=0&id=240c2fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports